type Platform = 'ANDROID' | 'IOS' | 'PC';

interface Category {
    categoryID: number;
    categoryName: string;
    picType: number | null;
    displayOrder: number | null;
    platforms: Platform[] | null;
    canChoose: boolean;
}
export interface Service {
    /** 服务商ID */
    serviceProviderID: number;

    /** 审核ID */
    serviceAuditID: number;

    /** 服务ID */
    serviceID: number;

    /** 服务名称 */
    serviceName: string;

    /**
     * `0` 美团页面
     * `1` 第三方页面
     */
    refType: 0 | 1;

    logo: string;

    /** 标签 */
    tags: string[];

    cities: {
        cityID: number;
        cityName: string;
    }[];

    /** 一级品类 */
    category: Category;

    /** 二级品类 */
    subCategory: Category;

    /**
     * 服务状态
     * - `0` 不展示
     * - `1` 正常
     */
    serviceStatus: 0 | 1;

    /**
     * 上架状态
     * - `0` 未上架
     * - `1` 上架
     */
    onlineStatus: 0 | 1;

    /**
     * 审核状态
     * - `0` 待审核
     * - `1` 已通过
     * - `2` 未通过
     */
    approvedStatus: 0 | 1 | 2;

    /**
     * 审核意见
     */
    opinion: string | null;

    /**
     * 处罚状态
     * - `1` 正常
     * - `2` 置休
     * - `3` 永久下架
     */
    punishStatus: 1 | 2 | 3;

    /**
     * 冻结天数
     *
     * 只有 `punishStatus` 为 `2` 的时候，此参数生效，其他状态此参数值为 `0`
     */
    pauseDay: number;

    /**
     * 恢复时间 "yyyy-MM-dd hh:mm"
     */
    releaseTime: string | null;

    /**
     * 修改时间（秒级时间戳）
     */
    modifyTime: number;

    /**
     * 活动状态（是否有生效或待生效活动）
     * - `0` 没有
     * - `1` 有
     */
    actStatus: number;

    /**
     * 新服务位
     * - `0` 否
     * - `1` 是
     */
    isNewItem: 0 | 1;

    /**
     * 新服务过期时间（秒级时间戳）
     */
    newItemPassTime: number;
}

export enum ReplyStatus {
    ALL = -1,
    NO_REPLY = 0,
    HAS_REPLY = 1,
}

export enum HasText {
    ALL = 0,
    YES = 1,
}
export interface Review {
    acctLogin: string;
    commentDetail: string;
    commentId: number;
    replyDetail: string;
    replyStatus: number;
    score: number;
    serviceName: string;
    timestamp: number;
    versionId: number;
    versionName: string;
}

export namespace ReviewApi {
    export namespace GetReviewList {
        export interface Req {
            score: number;
            replyStatus: number;
            hasText: number;
            itemId: number;
            startTime: number;
            endTime: number;
            pageNum: number;
            pageSize: number;
        }

        export type Res = Review[];
    }

    export namespace GetReviewListTotalNum {
        export interface Req {
            score: number;
            replyStatus: number;
            hasText: number;
            itemId: number;
            startTime: number;
            endTime: number;
        }

        export type Res = number;
    }
}
